import React from "react";
import PropTypes from "prop-types";
import cx from 'classnames';
import { Popup } from 'semantic-ui-react';

const Marker = props => {

	const {
		color,
		showTooltip,
		text,
		onClickTooltip
	} = props;
	const size = props.size && !isNaN(props.size) ? props.size : 0;
	const onClick = (value) => {
		return () => onClickTooltip ? onClickTooltip(value) : {};
	};

	let defaultCalcValue = 2;

	const faX = size === 1 ? "fa-lg" : "fa-" + size + "x";

	const wrapperClassNames = cx("fa-stack", faX, "map-marker", (color ? color : "blue"));
	const wrapperStyle = { bottom: defaultCalcValue + 'em', left: '-' + (defaultCalcValue / 2) + 'em' };
	const mapMarkerClassNames = cx("fa", "fa-map-marker", "fa-stack-" + defaultCalcValue + "x");
	const circleClassNames = cx("fa", "fa-circle", "fa-stack-" + defaultCalcValue + "x");
	const circlePositionStyle = { top: (4 * size) + 'px', "z-index": "-1" };

	const markerIcon = (<span className={wrapperClassNames} style={props.onMap ? wrapperStyle : null} onMouseEnter={onClick(true)} onMouseLeave={onClick(false)}>
		<i className={mapMarkerClassNames}></i>
		<i className={circleClassNames} style={circlePositionStyle}></i>
	</span>);

	if (text === "" || text === null || text === undefined)
		return markerIcon;

	return (<Popup trigger={markerIcon} content={text} />);
};

Marker.propTypes = {
	text: PropTypes.string,
	showTooltip: PropTypes.bool,
	onClickTooltip: PropTypes.func,
	color: PropTypes.string,
	size: PropTypes.number,
	onMap: PropTypes.bool
};
Marker.defaultProps = {
	size: 2
};

export default Marker;